import { inject, provide, computed } from 'vue'

export function useHeading(alignProp) {
  // Inject parent heading config, or fallback to left
  const parentHeading = inject('heading', { align: 'left' })

  // Ensure parentHeading.align is handled correctly if it's a Ref
  const parentAlignValue = computed(() => {
    return typeof parentHeading.align === 'object' &&
      'value' in parentHeading.align
      ? parentHeading.align.value
      : parentHeading.align
  })

  // `align` comes from props, fallback to injected heading align
  const align = computed(() => alignProp?.value || parentAlignValue.value)

  // Provide it for children
  provide('heading', {
    align: align,
  })

  // Map align to Vuetify-style justify values
  const justify = computed(() => {
    switch (align.value) {
      case 'center':
        return 'center'
      case 'right':
        return 'end'
      default:
        return 'start'
    }
  })

  return {
    align,
    justify,
  }
}
